// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, Promise] = chunk loading, 0 = chunk loaded
const installedChunks = {
	"@templates/page@2026": 0,
	"sec/S5-07-A/W1": 0,
	"sec/R2-14/cheat": 0,
	"sec/R1-11/TD": 0,
	"sec/R1-11/CM": 0,
	"dev/R6-01-VCOD/CM": 0,
	"dev/R4-01/cheat": 0,
	"web/R3-03/W4/TP": 0,
	"web/R3-03/W4/CM": 0,
	"web/R3-03/W3/TP": 0,
	"web/R3-03/W3/CM": 0,
	"web/R3-03/W2/CM": 0,
	"web/R3-03/W1/CM": 0,
	"sec/R4-10-VCOD/W1/TP": 0,
	"sec/R4-10-VCOD/W1/CM": 0,
	"sec/R3-12-VCOD/W3/CM": 0,
	"sec/R3-12-VCOD/W2/TP": 0,
	"sec/R3-12-VCOD/W2/TD": 0,
	"sec/R2-14/W4/CM": 0,
	"sec/R2-14/W3/CM": 0,
	"sec/R2-14/W2/CM": 0,
	"sec/R2-14/W1/CM": 0,
	"dev/R5-06-VCOD-B/W3/CM": 0,
	"dev/R5-06-VCOD-B/W2/CM": 0,
	"dev/R5-06-VCOD-B/W1/CM": 0,
	"dev/R5-06-VCOD-A/W3/CM": 0,
	"dev/R5-06-VCOD-A/W2/TD": 0,
	"dev/R5-06-VCOD-A/W2/CM": 0,
	"dev/R5-06-VCOD-A/W1/CM": 0,
	"dev/R4-01/W4/CM": 0,
	"dev/R4-01/W3/CM": 0,
	"dev/R4-01/W2/CM": 0,
	"dev/R4-01/W1/CM": 0,
	"acc/R1-13/W2/TP": 0,
	"acc/R1-13/W2/CM": 0,
	"acc/R1-13/W3/cheat": 0,
	"acc/R1-13/W3/CM": 0,
	"acc/R1-13/W1/TP": 0
};

const installChunk = (data) => {
	let {__webpack_esm_ids__, __webpack_esm_modules__, __webpack_esm_runtime__} = data;
	// add "modules" to the modules object,
	// then flag all "ids" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	for(moduleId in __webpack_esm_modules__) {
		if(__webpack_require__.o(__webpack_esm_modules__, moduleId)) {
			__webpack_require__.m[moduleId] = __webpack_esm_modules__[moduleId];
		}
	}
	if(__webpack_esm_runtime__) __webpack_esm_runtime__(__webpack_require__);
	for(;i < __webpack_esm_ids__.length; i++) {
		chunkId = __webpack_esm_ids__[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}

}

// no chunk on demand loading

// no prefetching

// no preloaded

__webpack_require__.C = installChunk;

// no on chunks loaded
// no HMR

// no HMR manifest